import { render, staticRenderFns } from "./CatalogueForm.vue?vue&type=template&id=399ae5b2"
import script from "./CatalogueForm.vue?vue&type=script&lang=js"
export * from "./CatalogueForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports